import { gql } from "@apollo/client";

export const FETCH_AVAILABLE_PAYMENT_PROVIDERS = gql`
    query fetchAvailablePaymentProviders {
        providers: available_payment_providers {
            id
            displayName
            enabled
        }
    }
`;

export const UPDATE_MY_PAYMENT_PROVIDER_CONFIG = gql`
    mutation updateMyPaymentProviderConfig($input: update_payment_provider_config_input!) {
        config: update_payment_provider_config(input: $input) {
            profile {
                payment_provider_config {
                    id
                }
            }
        }
    }
`;

export const UPDATE_MY_PAYMENT_PROVIDER_CONFIG_STATUS = gql`
    mutation updateMyPaymentProviderConfigStatus($input: update_payment_provider_config_input!) {
        config: update_payment_provider_config(input: $input) {
            profile {
                payment_provider_config {
                    id
                    provider_id
                    status
                }
            }
        }
    }
`;
